export const FOOTER_HEIGHT = 68;
export const LAST_QUESTION_NO_OF_FIRST_ACTIVITY = 21;
